export default "__VITE_ASSET__CuBPSkTx__"